"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentLoading = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const Spinner_1 = require("Views/Shared/Components/Spinner/Spinner");
const ContentLoading = ({ className = '' }) => ((0, jsx_runtime_1.jsx)("div", { className: "spinner-wrapper relative h-screen", children: (0, jsx_runtime_1.jsx)(Spinner_1.Spinner, { visible: true, className: (0, app_1.cn)('spinner !top-18', className) }) }));
exports.ContentLoading = ContentLoading;
